import React from 'react'
import { Outlet } from 'react-router-dom'

const Location = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Location;